<template>
  <!-- <section id="dashboard-analytics">
    <b-row class="match-height">
      <b-col lg="6" md="12">
        <DashboardHello />
      </b-col>
    </b-row>
  </section> -->
  <div>
    Bonjour !
  </div>
</template>

<script>

export default {
  components: {
    // DashboardHello: () => import('./DashboardHello.vue')
  }
}
</script>

<style lang="scss">
.app-content {
  padding: 1rem 2rem 0;
  &.content {
    margin-left: 260px;
  }
}
</style>